import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './Pages/Dashboard';
import BusinessListings from './Pages/BusinessListings';
import CategoryListings from './Pages/CategoryListings';
import ViewListings from './Pages/ViewListings';
import EditListings from './Pages/EditListings';
import AddListings from './Pages/AddListings';
import AdListings from './Pages/AdListings';
import AddCategory from './Pages/AddCategory';
import EditCategory from './Pages/EditCategory';
import ViewCategory from './Pages/ViewCategory';
import CustomAd from './Pages/CustomAd';
import AddCity from './Pages/AddCity';
import EditCity from './Pages/EditCity';
import ViewCity from './Pages/ViewCity';
import BlogListings from './Pages/BlogListings';  
import BlogViewPage from './Pages/BlogViewPage';
import BlogEditPage from './Pages/BlogEditPage';
import FaqListing from './Pages/FaqListing';  
import UserManagement from './Pages/UserManagement';
import PageManagement from './Pages/PageManagemnent';
import Email from './Pages/Email';
import Login from './Pages/Login';
import Logout from './Pages/Logout';
import Theme from './Theme'; 
import './App.css';

import RequireAuth from './RequireAuth';
import PublicAuth from './PublicAuth';
import RevenueTracking from './Pages/RevenueTracking';
import PaymentPage from './Pages/Payment';
import BusinessPromotion from './Pages/BusinessPromotion';
import CityListings from './Pages/CityListings';
import AdManagemnent from './Pages/AdManagement';
import Loader from './Layout/Loader';
import PetCategoryListings from './Pages/PetCategroyListings';
import AddPetCategory from './Pages/AddPetCategory';
import EditPetCategory from './Pages/EditPetCategory';
import ViewPetCategory from './Pages/ViewPetCategory';
import FaqViewPage from './Pages/FaqViewPage';
import FaqEditPage from './Pages/FaqEditPage';
import ReviewManagement from './Pages/ReviewManagement';
import AddReview from './Pages/AddReview';
import ViewReviews from './Pages/ViewReviews';
import CustomPages from './Pages/CustomPages';
import HomePage from './Pages/HomePage';
import SeoInformation from './Pages/SeoInformation';
import CreateNewCustomPage from './Pages/CreateNewCustomPage'
import CategoryPages from "./Pages/CategoryPages"
import AddCategoryPage from './Pages/AddCategoryPage';
import EditProfile from './Pages/EditProfile';
import ChangePassword from './Pages/ChangePassword';
import SessionTimeoutHandler from './Hooks/SessionTimeoutHandler'; 
import ForgotPassword from "./Pages/ForgotPassword";
import ResetPassword from "./Pages/ResetPassword";
import DirectoryBannerManagement from './Pages/DirectoryBannerManagement';
import CityBannerManagement from './Pages/CityBannerManagement';
import AddCityBanner from "./Pages/AddCityBanner";
import BlogBannerManagement from './Pages/BlogBannerManagement';
import UserDetails from "./Pages/UserDetails";
import EnquiryList from "./Pages/EnquiryList";
import SpecializedServicesListings from './Pages/SpecializedServicesListings';
import AddEditSpecializedService from './Pages/AddEditSpecializedService';
import OfferListings from './Pages/OffersManagement';
import OffersAnalytics from './Pages/OffersAnalytics';
import AddEditOffers from './Pages/AddEditOffers';
import PaymentSettings from './Pages/PaymentSettings';

function App() {
  
  const [loading, setLoading] = useState(true);
  useEffect(()=> {
    const timer = setTimeout(() => {
      console.log("loading")
      setLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);
  if(loading) {
    return <Loader />;
  }
  return (
    <Router>
      <SessionTimeoutHandler />
      <Routes>
        {/* Login route shown first */}
        <Route path="/login" element={<PublicAuth><Login /></PublicAuth>} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Protected admin layout route */}
        <Route path="/" element={<RequireAuth><Theme /></RequireAuth>}>
          <Route index element={<Navigate to="dashboard" />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="business-listing" element={<BusinessListings />} />
          <Route path="add-listing" element={<AddListings />} />
          <Route path="edit-category" element={<EditCategory />} />
          <Route path="view-category" element={<ViewCategory />} />
          <Route path="category-listing" element={<CategoryListings />} />
          <Route path="add-category" element={<AddCategory />} />
          <Route path="city-listing" element={<CityListings />} />
          <Route path="add-city" element={<AddCity />} />
          <Route path="edit-city" element={<EditCity />} />
          <Route path="view-city" element={<ViewCity />} />
          <Route path="view-listing" element={<ViewListings />} />
          <Route path="edit-listing" element={<EditListings />} />
          <Route path="blog-listing" element={<BlogListings />} />
          <Route path="blogs/new" element={<BlogEditPage />} />
          <Route path="blogs/:id" element={<BlogViewPage />} />
          <Route path="blogs/:id/edit" element={<BlogEditPage />} />
          <Route path="blog-listing" element={<BlogListings />} />
          <Route path="faq-listing" element={<FaqListing />} />
          <Route path="faq/:id" element={<FaqViewPage />} />
          <Route path="faq/:id/edit" element={<FaqEditPage />} />
          <Route path="faq/new" element={<FaqEditPage />} />
          <Route path="user-management" element={<UserManagement />} />
          <Route path="ad-management" element={<AdManagemnent />} />
          <Route path="custom-ad" element={<CustomAd />} />
          <Route path="pet-category-listing" element={<PetCategoryListings />} />
          <Route path="add-pet-category" element={<AddPetCategory />} />
          <Route path="edit-pet-category" element={<EditPetCategory />} />
          <Route path="view-pet-category" element={<ViewPetCategory />} />
          <Route path="review-management" element={<ReviewManagement />} />
          <Route path="ad-listing" element={<AdListings />} />
          <Route path="page-management" element={<PageManagement />} />
          <Route path="email" element={<Email />} />
          <Route path="payments" element={<PaymentPage />} />
          <Route path="promotion" element={<BusinessPromotion />} />
          <Route path="revenue-tracking" element={<RevenueTracking />} />
          <Route path="logout" element={<Logout />} />
          <Route path="add-review/:listingId" element={<AddReview />} />
          <Route path="reviews/:id" element={<ViewReviews />} />
          <Route path='custom-pages' element={<CustomPages />} />
          <Route path='home-page' element={<HomePage />} />
          <Route path='seo-information' element={<SeoInformation />} />
          <Route path='custom-page/new' element={<CreateNewCustomPage />}/>
          <Route path="custom-page/edit" element={<CreateNewCustomPage />} />
          <Route path='/category-pages' element={<CategoryPages/>} />
          <Route path='/category-pages/add' element={<AddCategoryPage/>} />
          <Route path='/category-pages/edit' element={<AddCategoryPage/>} />
          <Route path='/ad-management/edit' element={<AdManagemnent/>} />
          <Route path="/edit-profile" element={<EditProfile />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/directory-banner-management" element={<DirectoryBannerManagement />} />
          <Route path="/blog-banner-management" element={<BlogBannerManagement />} />
          <Route path="/city-banner-management" element={<CityBannerManagement />} />
          <Route path="/add-city-banner" element={<AddCityBanner />} />
          <Route path="/user-details/:id" element={<UserDetails />} />
          <Route path='/enquiry-list' element={<EnquiryList />} />
          <Route path='/specialized-services-listing' element={<SpecializedServicesListings />} />
          <Route path='/edit-specialized-service/:id' element={<AddEditSpecializedService />} />
          <Route path='/add-specialized-service' element={<AddEditSpecializedService />} />
          <Route path='/offers-management' element={<OfferListings />} />
          <Route path='/add-edit-offers' element={<AddEditOffers />} />
          <Route path='/offers-analytics' element={<OffersAnalytics />} />
          <Route path='/payment-settings' element={<PaymentSettings/>} />
          

        </Route>
        

        {/* Redirect unknown paths to login */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
}

export default App;
